import type { Itinerary } from '$/models/Itinerary.model.ts';
import type { CodySuggestion } from '$/requests/locationBasedCodySuggestions.ts';

export const SUGGESTIONS_WAIT_MS = 3 * 60 * 1000;

const currentCodySuggestions = (suggestions: CodySuggestion[] | null): CodySuggestion[] =>
  (suggestions ?? []).filter((suggestion) => suggestion.retired !== true);

export const areCodySuggestionsPending = (
  itinerary: Pick<Itinerary, 'cody_suggestions_pending' | 'cody_suggestions_requested_at'> | null | undefined,
  now: number
): boolean => {
  if (!itinerary?.cody_suggestions_pending || !itinerary.cody_suggestions_requested_at) return false;

  return now - Date.parse(itinerary.cody_suggestions_requested_at) < SUGGESTIONS_WAIT_MS;
};

export default currentCodySuggestions;
